module.exports = __webpack_public_path__ + "img/hopways-02.4ba51848.jpeg";